import React, { ReactNode } from 'react';

/**
 * Utility to convert URLs in text to clickable <a> elements
 * @param text The text which could contain links in plain-text.
 * @returns An array of reactNodes where each node is either a link (<a>) or text-part (<span>)
 */
const parseTextWithLinksToHtml = (text: string): ReactNode[] => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  const textParts = text.split(urlRegex);

  const textPartElements = textParts.map<ReactNode>((part, index) => (
    urlRegex.test(part) 
      ? 
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
        {part}
        </a>
      : 
        <span key={index}>{part}</span>
  ));

  return textPartElements;
}

export {
  parseTextWithLinksToHtml
}
